<script setup>
import { onMounted, ref, watch } from "vue";
import { useRouter } from 'vue-router';
import { fetchParks } from "@/remote/park";
import { fetchParkIssues } from "@/remote/issue.js";

const router = useRouter();

const parks = ref([]);
const selectedParkId = ref(null);

function openDoMaint() {
  router.push(`/domaintenance/${selectedParkId.value}/`);
}

onMounted(async () => {
  parks.value = await fetchParks();
});

const loadingIssues = ref(false);
const hasIssuesOpen = ref(false);
watch(selectedParkId, async (value) => {
  if (value === null) {
    hasIssuesOpen.value = false;
    return;
  }
  loadingIssues.value = true;
  try {
    const issues = await fetchParkIssues(value);
    hasIssuesOpen.value = issues.length > 0;
  } finally {
    loadingIssues.value = false;
  }
});
fetchParkIssues()
;</script>

<template>
  <v-container>
    <form @submit.prevent="openDoMaint">
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-autocomplete
            label="Park to modify"
            :items="parks"
            v-model="selectedParkId"
            item-title="name"
            item-value="id"
            hide-details
            density="compact"
          />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn
          class="w-full"
          type="submit"
          :disabled="selectedParkId === null || loadingIssues"
        >Start Maintenance
        </v-btn>
      </v-row>
      <template v-if="selectedParkId !== null">
        <v-row justify="center" v-if="loadingIssues">
          Checking Issues...
        </v-row>
        <v-row justify="center" v-else-if="hasIssuesOpen">
          <span class="text-red">There are opened issues!</span>
        </v-row>
        <v-row justify="center" v-else>
          No issues open
        </v-row>
      </template>
    </form>
  </v-container>
</template>

<style scoped>

</style>
